import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import { reducer as notificationsReducer } from 'reapop';

import { LOGOUT_SUCCESS, LOGOUT_FAILURE } from '../constants/ActionTypes';
import Appraisal from './Appraisal';
import AgreementsReducer from './AgreementsReducer';
import BirthdaysReducer from './BirthdaysReducer';
import careerReducer from './careerReducer';
import certificateReducer from './certificateReducer';
import CourseEvaluationReducer from './CourseEvaluationReducer';
import CourseQuestionnaireReducer from './CourseQuestionnaireReducer';
import coursesReducer from './coursesReducer';
import educationReducer from './educationReducer';
import EmployeeHolidayReducer from './EmployeeHolidayReducer';
import EmployeeBankReducer from '././EmployeeBankReducer';
import EmployeeSearch from './EmployeeSearch';
import EmployeeTaxCardsReducer from './EmployeeTaxCardsReducer';
import EmployeePensionAndUnionReducer from './EmployeePensionAndUnionReducer';
import EntityCRUD from './EntityCRUD';
import FileReducer from './FileReducer';
import languageReducer from './languageReducer';
import loginReducer from './loginReducer';
import ManagerAppraisal from './ManagerAppraisal';
import Notification from '././Notification';
import profileReducer from './profileReducer';
import qualificationReducer from './qualificationReducer';
import SettingsReducer from './SettingsReducer';
import WebValuesReducer from './WebValuesReducer';
import EmployeeOrgChart from './EmployeeOrgChart';
import BenefitsReducer from './BenefitsReducer';
import loansReducer from './loansReducer';
import perDiemReducer from './PerDiem';
// New way
import TG from '../sites/transportationGrants';
import time from '../sites/time';
import teria from '../sites/teria';
import inOut from '../sites/inOut';
import vacationApprovals from '../sites/vacationApprovals';
import payTickets from '../sites/payTickets';
import approvalRequests from '../sites/approvalRequests';

const appReducer = combineReducers({
  Appraisal,
  AgreementsReducer,
  BirthdaysReducer,
  BenefitsReducer,
  careerReducer,
  certificateReducer,
  CourseEvaluationReducer,
  CourseQuestionnaireReducer,
  coursesReducer,
  educationReducer,
  EmployeeBankReducer,
  EmployeeHolidayReducer,
  EmployeeOrgChart,
  EmployeeSearch,
  EmployeeTaxCardsReducer,
  EmployeePensionAndUnionReducer,
  EntityCRUD,
  FileReducer,
  form,
  languageReducer,
  loginReducer,
  ManagerAppraisal,
  Notification,
  notifications: notificationsReducer(),
  profileReducer,
  qualificationReducer,
  routing: routerReducer,
  WebValuesReducer,
  SettingsReducer,
  TransportationGrantReducer: TG.reducer,
  loansReducer,
  timeReducer: time.reducer,
  teriaReducer: teria.reducer,
  inOutReducer: inOut.reducer,
  vacationApprovalsReducer: vacationApprovals.reducer,
  perDiemReducer,
  payticketReducer: payTickets.reducer,
  approvalRequestsReducer: approvalRequests.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_FAILURE || action.type === LOGOUT_SUCCESS) {
    const routing = state.routing;
    return appReducer({ routing }, action);
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js